import { StateRepository } from '@angular-ru/ngxs/decorators';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State, StateToken, Store } from '@ngxs/store';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import {
    IProductCategoryAvailability,
    IProductCategoryContext,
    IProductContextAssessmentStatus,
    IProductContextCase,
    IProductContextCaseStatus,
    IProductContextMetadataOwner,
    IProductInterviewConfig,
    IProductSmartActionReference,
    IProductStage
} from 'src/app/models/case';
import { INotification } from 'src/app/models/notifications';
import { Product, ProductAvailability } from 'src/app/models/product';
import { SignalREvent } from 'src/app/models/signalr';
import { IInterviewHandler } from 'src/app/shared/interview-new/models/interview-handler.models';
import { InterviewHandlerService } from 'src/app/shared/interview-new/services/interview-handler.service';
import { FeatureService } from 'src/app/shared/preview-feature/preview-feature.service';

import { TaskOrchestratorService } from 'src/app/services/task-orchestrator/task-orchestrator.service';
import { BaseProductServiceSingle } from '../-base-product.service-single';
import { CaseService } from '../../case/case.service';
import { interviewVeteranDataProviderToken } from '../../interview-providers/interview-data-provider.tokens';
import { IDisqualificationReason } from '../../interview/interview.model';
import { MemberService } from '../../member/member.service';
import { ProductContextService } from '../../product-context/product-context.service';
import { TaskServiceFactory, TaskServiceFactoryFn } from '../../task/task.service';
import { UserService } from '../../user/user.service';
import { MEDICAID_TOKEN_TOKEN, MedicaidStateModel, ProductNameManagedRetention } from '../medicaid/medicaid.state.models';
import { AlertService } from './../../alert.service';
import { GlobalService } from './../../global/global.service';
import { VeteranInterviewData } from './veteran-interview-data';
import { VeteranStateModel } from './veteran.state.models';

export const VETERAN_TOKEN_KEY = 'veteranState';
export const VETERAN_TOKEN_TOKEN = new StateToken<VeteranService>(VETERAN_TOKEN_KEY);

@StateRepository()
@State<VeteranStateModel>({
    name: VETERAN_TOKEN_TOKEN,
    defaults: {

    }
})
@Injectable()
export class VeteranService extends BaseProductServiceSingle<VeteranStateModel> {

    get stateToken() {
        return VETERAN_TOKEN_TOKEN;
    }

    // get status$(): Observable<IProductContextCaseStatus> {
    //     return this.store.select<IProductContextCaseStatus>(VeteranService.status);
    // }

    // get statusSync(): IProductContextCaseStatus {
    //     return this.store.selectSnapshot<IProductContextCaseStatus>(VeteranService.status);
    // }

    // get caseOwner$(): Observable<IProductContextMetadataOwner> {
    //     return this.store.select<IProductContextMetadataOwner>(VeteranService.owner);
    // }

    // get caseOwnerSync(): IProductContextMetadataOwner {
    //     return this.store.selectSnapshot<IProductContextMetadataOwner>(VeteranService.owner);
    // }

    // get sourceProduct$(): Observable<Product> {
    //     return this.store.select<Product>(VeteranService.sourceProduct);
    // }

    // protected get productCategoryContextSync(): IProductCategoryContext {
    //     return this.store.selectSnapshot<IProductCategoryContext>(VeteranService.productCategoryContext);
    // }

    // get productCategoryContext$(): Observable<IProductCategoryContext> {
    //     return this.store.select<IProductCategoryContext>(VeteranService.productCategoryContext);
    // }

    // get metadataSync(): any {
    //     return this.store.selectSnapshot<IProductContextCase>(VeteranService.metadata);
    // }
    // get metadata$(): Observable<any> {
    //     return this.store.select<any>(VeteranService.metadata);
    // }

    // get currentCaseSync(): IProductContextCase {
    //     return this.store.selectSnapshot<IProductContextCase>(VeteranService.currentCase);
    // }
    // get currentCase$(): Observable<IProductContextCase> {
    //     return this.store.select<IProductContextCase>(VeteranService.currentCase);
    // }

    // get caseStageSync(): IProductStage {
    //     return this.store.selectSnapshot<IProductStage>(VeteranService.caseStage);
    // }
    // get caseStage$(): Observable<IProductStage> {
    //     return this.store.select<IProductStage>(VeteranService.caseStage);
    // }

    // get notifications$(): Observable<INotification[]> {
    //     return this.store.select<INotification[]>(VeteranService.notifications);
    // }

    // get productInterviewsSync(): IProductInterviewConfig[] {
    //     return this.store.selectSnapshot<IProductInterviewConfig[]>(VeteranService.productInterviews);
    // }

    // get productInterviews$(): Observable<IProductInterviewConfig[]> {
    //     return this.store.select<IProductInterviewConfig[]>(VeteranService.productInterviews);
    // }

    // get caseAssessmentSync(): IProductContextAssessmentStatus {
    //     return this.store.selectSnapshot<IProductContextAssessmentStatus>(VeteranService.caseAssessment);
    // }
    // get caseAssessment$(): Observable<IProductContextAssessmentStatus> {
    //     return this.store.select<IProductContextAssessmentStatus>(VeteranService.caseAssessment);
    // }

    // get iconSync(): string {
    //     return this.store.selectSnapshot<string>(VeteranService.icon);
    // }
    // get icon$(): Observable<string> {
    //     return this.store.select<string>(VeteranService.icon);
    // }

    // get noCaseMessageSync(): string {
    //     return this.store.selectSnapshot<string>(VeteranService.noCaseMessage);
    // }
    // get noCaseMessage$(): Observable<string> {
    //     return this.store.select<string>(VeteranService.noCaseMessage);
    // }

    // get categoryDisplayNameSync(): string {
    //     return this.store.selectSnapshot<string>(VeteranService.categoryDisplayName);
    // }
    // get categoryDisplayName$(): Observable<string> {
    //     return this.store.select<string>(VeteranService.categoryDisplayName);
    // }

    // get stagesSync(): IProductStage[] {
    //     return this.store.selectSnapshot<IProductStage[]>(VeteranService.stages);
    // }
    // get stages$(): Observable<IProductStage[]> {
    //     return this.store.select<IProductStage[]>(VeteranService.stages);
    // }

    // get smartActionsSync(): IProductSmartActionReference[] {
    //     return this.store.selectSnapshot<IProductSmartActionReference[]>(VeteranService.smartActions);
    // }
    // get smartActions$(): Observable<IProductSmartActionReference[]> {
    //     return this.store.select<IProductSmartActionReference[]>(VeteranService.smartActions);
    // }

    get interviewDataProviderToken() {
        return interviewVeteranDataProviderToken;
    }


    constructor(
        globalService: GlobalService,
        memberService: MemberService,
        userService: UserService,
        caseService: CaseService,
        productContextService: ProductContextService,
        confirmationService: ConfirmationService,
        router: Router,
        route: ActivatedRoute,
        alertService: AlertService,
        store: Store,
        featureService: FeatureService,
        taskOrchestratorService: TaskOrchestratorService,
        @Inject(TaskServiceFactory) taskService: TaskServiceFactoryFn
    ) {
        super(
            'VA',
            memberService,
            userService,
            caseService,
            productContextService,
            confirmationService,
            router,
            route,
            alertService,
            VeteranInterviewData,
            store,
            featureService,
            new InterviewHandlerService(),
            taskOrchestratorService
        );

        this.taskService = taskService().setContext();
        this.taskService.activate();
    }


    signalRFilter(event: SignalREvent): boolean {
        return true;
    }

    async canInterviewAdvanceStage(status: string, disqualificationReason: IDisqualificationReason, interviewHandler: IInterviewHandler) {
        return (disqualificationReason != null || 'Engagement' === this.caseStageSync.name);
    }

    isSameCategory(interviewCategory: string): boolean {
        return super.isSameCategory(interviewCategory) || !!['VA', 'VETERAN'].find(category => interviewCategory?.toUpperCase().includes(category));
    }

    getAvailability(avail: IProductCategoryAvailability): IProductCategoryAvailability {
        const medicaidState = this.store.selectSnapshot<MedicaidStateModel>(MEDICAID_TOKEN_TOKEN);

        if (medicaidState.sourceProduct && medicaidState.sourceProduct.name.toUpperCase() === ProductNameManagedRetention) {
            return { available: false, availabilityReason: ProductAvailability.Disabled, stageDisplayName: 'Disallowed for Managed Medicaid' } as IProductCategoryAvailability;
        }

        return avail;
    }

    async customizeAvailability(avail: IProductCategoryAvailability): Promise<IProductCategoryAvailability> {
        const medicaidState = await this.store.select<MedicaidStateModel>(MEDICAID_TOKEN_TOKEN).pipe(filter(_ => !!_), first()).toPromise();

        if (medicaidState.sourceProduct && medicaidState.sourceProduct.name.toUpperCase() === ProductNameManagedRetention) {
            return { available: false, availabilityReason: ProductAvailability.Disabled, stageDisplayName: 'Disallowed for Managed Medicaid' } as IProductCategoryAvailability;
        }

        return avail;
    }
}
